import { DeleteOutlined } from '@ant-design/icons'
import { Button, Form, Input } from 'antd'
import PropTypes, { array, bool, func, object, shape, string } from 'prop-types'
import React, { useMemo } from 'react'
import InfoField from '~/components/infoField'

const ApiField = ({
	pageFieldsData,
	inputValue,
	onChange,
	OutsideLabel,
	className,
}) => {
	const {
		label,
		variable,
		info,
		optional,
		placeholder,
		visible,
		list,
		api_list,
	} = pageFieldsData

	const returnLabel = () => {
		if (label.length > 0) {
			return (
				<div style={{ marginBottom: '8px' }}>
					<InfoField label={label} info={info} />
				</div>
			)
		} else if (OutsideLabel?.length > 0) {
			return <InfoField label={OutsideLabel} info={info} />
		}
		return null
	}

	const initialValues = useMemo(() => {
		if (inputValue.length > 0) {
			return inputValue
		} else {
			return [{ [variable.list_object_property]: '' }]
		}
	}, [inputValue, variable.list_object_property])

	return (
		<div className={className}>
			{returnLabel()}
			<Form.List
				name={list !== undefined ? [list, variable.name] : variable.name}
				initialValue={initialValues}
				label={'qual é?'}>
				{(fields, { add, remove }) => (
					<>
						{fields.map((field) => {
							return (
								<div key={field.key} style={{ marginBottom: '8px' }}>
									<Form.Item
										noStyle
										key={field.key}
										name={[field.name, variable.list_object_property]}
										getValueFromEvent={(e) => {
											return e.target.value.trim()
										}}
										rules={
											visible && [
												{ required: !optional, message: 'Campo obrigatório' },
											]
										}
										onChange={(e) => onChange()}>
										<Input style={{ width: '50%' }} placeholder={placeholder} />
									</Form.Item>
									{api_list && (
										<Button
											type="link"
											icon={<DeleteOutlined />}
											onClick={() => remove([field.name, 'apiField'])}
										/>
									)}
								</div>
							)
						})}
						{api_list && (
							<Form.Item>
								<Button
									type="primary"
									onClick={() => add()}
									style={{ width: '150px' }}
									block>
									Adicionar Item
								</Button>
							</Form.Item>
						)}
					</>
				)}
			</Form.List>
		</div>
	)
}

ApiField.propTypes = {
	pageFieldsData: shape({
		label: string.isRequired,
		variable: PropTypes.oneOfType([object, string]),
		type: string.isRequired,
		info: string,
	}).isRequired,
	inputValue: array.isRequired,
	className: string,
	onChange: func,
	onFocus: func,
	first: bool,
	disabled: bool,
	visible: bool,
	typeOfText: string,
	OutsideLabel: string,
}

ApiField.defaultProps = {
	inputValue: '',
	OutsideLabel: '',
	visible: true,
}

export default ApiField
